import { Box, Container, Flex, FullPage, Grid } from '@backstage/ui';
import {
  configApiRef,
  featureFlagsApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WelcomeBanner } from './WelcomeBanner';
import toolkit from './toolkit';
import { ToolkitCard } from './ToolkitCard';
import { OpenPullRequestsCard } from './OpenPullRequestsCard';
import { NeedsYouCard } from './needsYou/NeedsYouCard';
import { StarredEntitiesCard } from './StarredEntitiesCard';
import { HomePageAiSpendCard } from '@internal/plugin-ai-spend-monitor';
import { MessageOfTheDay } from '../MessageOfTheDay';
import { getFlag } from '../../helpers/helpers';

/** User feature flag that replaces "Your open pull requests" with "Needs you". */
export const HOME_NEEDS_YOU_FLAG = 'home-needs-you';

const HomePage = () => {
  const config = useApi(configApiRef);
  const featureFlags = useApi(featureFlagsApiRef);
  const needsYou = featureFlags.isActive(HOME_NEEDS_YOU_FLAG);
  return (
    <FullPage>
      <Container pt="3" pb="6">
        <Flex direction="column" gap="4">
          <Box py="1">
            <WelcomeBanner />
          </Box>
          <MessageOfTheDay />
          <Grid.Root columns={{ initial: '1', md: '3' }} gap="4">
            {/* "Your work" is the card people act on, so it leads and takes
            two of the three columns; the other cards stack beside it. */}
            {needsYou && (
              <Grid.Item colSpan={{ md: '2' }} rowSpan={{ md: '2' }}>
                <NeedsYouCard />
              </Grid.Item>
            )}
            {getFlag(config, 'ai-spend-card') && (
              <Grid.Item>
                <HomePageAiSpendCard />
              </Grid.Item>
            )}
            <Grid.Item>
              <ToolkitCard tools={toolkit} />
            </Grid.Item>
            {!needsYou && (
              <Grid.Item>
                <OpenPullRequestsCard />
              </Grid.Item>
            )}
            <Grid.Item>
              <StarredEntitiesCard />
            </Grid.Item>
          </Grid.Root>
        </Flex>
      </Container>
    </FullPage>
  );
};

export default HomePage;
